import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["aria-label", "title", "disabled"]


export default /*#__PURE__*/_defineComponent({
  __name: 'BtnIcon',
  props: {
    ariaLabel: {},
    iconName: {},
    disabled: { type: Boolean },
    pressed: { type: Boolean },
    size: {},
    rotation: {},
    variant: {},
    title: {}
  },
  emits: ["click"],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    "data-ts": "btn-icon",
    class: _normalizeClass([
			'icon-button',
			{
				'icon-button--small': _ctx.size === 'small',
				'icon-button--secondary': _ctx.variant === 'secondary',
				'icon-button--pressed': _ctx.pressed,
			},
		]),
    "aria-label": _ctx.ariaLabel,
    title: _ctx.title,
    disabled: _ctx.disabled,
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click', $event))),
    onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(($event: any) => (_ctx.$emit('click', $event)), ["prevent"]), ["enter"]))
  }, [
    _createElementVNode("span", {
      class: _normalizeClass(`icon-button__icon bx ${_ctx.iconName}`),
      "data-ts": "icon",
      style: _normalizeStyle({ transform: `rotate(${_ctx.rotation}deg)` })
    }, null, 6)
  ], 42, _hoisted_1))
}
}

})